import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";

import { Profile } from "../../../../models";
import { ProfileService, UserService } from "../../../../services";

@Component({
  selector: "follow-button",
  templateUrl: "./follow-button.component.html",
  styleUrls: ["../../../../../../assets/icon/icofont/css/icofont.scss"],
})
export class FollowButtonComponent {
  constructor(
    private profileService: ProfileService,
    private router: Router,
    private userService: UserService
  ) {}

  @Input() profile: Profile;
  @Output() onToggle = new EventEmitter<boolean>();
  public isSubmitting = false;

  ngOnInit() {}

  public toggleFollowing() {
    this.isSubmitting = true;

    this.userService.isAuthenticated.subscribe((authenticated) => {
      // Not authenticated? Push to login screen
      if (!authenticated) {
        this.router.navigateByUrl("/login");
        return;
      }

      // Follow this profile if we aren't already
      if (!this.profile.isFollowing.following) {
        this.profileService.follow(this.profile.username).subscribe(
          (data) => {
            this.isSubmitting = false;
            this.onToggle.emit(true);
          },
          (err) => (this.isSubmitting = false)
        );

        // Otherwise, unfollow this profile
      } else {
        this.profileService.unfollow(this.profile.username).subscribe(
          (data) => {
            this.isSubmitting = false;
            this.onToggle.emit(false);
          },
          (err) => (this.isSubmitting = false)
        );
      }
    });
  }
}

export class AppModule {}
